import { render, staticRenderFns } from "./CoolingAirControls.vue?vue&type=template&id=445308a6&"
import script from "./CoolingAirControls.vue?vue&type=script&lang=ts&"
export * from "./CoolingAirControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports